<img [src]="logo" alt="Logo" [class]="classes">
